import React from "react";
import {alpha, Box, Collapse, IconButton, Stack, useTheme,} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {TreeInput} from "../general/inputs/TreeInput";
import PropTypes from "prop-types";

export default function LineLabel(props) {
    const theme = useTheme();
    const {value, onValueChange, onInputFocus, editable, children} = props;
    const [open, setOpen] = React.useState(false);

    const handleChange = (event) => {
        event.preventDefault();
        onValueChange(event.target.value);
    };

    const handleKeyDown = (event) => {
        switch (event.which) {
            case 9: // Tab
                event.preventDefault();
                if (event.target) {
                    let root = event.target.closest(".MuiTreeItem-root");
                    if (root) {
                        let next;
                        if (event.shiftKey)
                            next = root.previousElementSibling;
                        else
                            next = root.nextElementSibling;
                        if (next) {
                            let input = next.querySelector("textarea");
                            if (input)
                                input.focus();
                        }
                    }
                }
                break;
            default:
        }
    }

    return (
        <Stack>
            <Stack direction="row" spacing={1} alignItems="center">
                <TreeInput
                    fullWidth
                    disabled={!editable}
                    disableUnderline={!editable}
                    multiline
                    maxRows={15}
                    size="small"
                    type="text"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onFocus={onInputFocus}
                />
                {children && (
                    <Box pb={1} pt={1} display="flex" alignItems="end">
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <ExpandLessIcon fontSize="small"/> : <ExpandMoreIcon fontSize="small"/>}
                        </IconButton>
                    </Box>
                )}
            </Stack>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box
                    margin={1}
                    pt={2}
                    borderTop={editable
                        ? `solid 1px ${alpha("#000000", 0.0)}`
                        : `solid 1px ${theme.palette.text.secondary}`
                    }
                >
                    {children}
                </Box>
            </Collapse>
        </Stack>

    );
}

LineLabel.propTypes = {
    value: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    onInputFocus: PropTypes.func,
    editable: PropTypes.bool.isRequired,
}

LineLabel.defaultProps = {
    onInputFocus: () => {
    }
}